export enum StoreSetupRoute {
  Form = 'form',
  Intro = 'intro',
}
